import clone from 'rfdc/default';
import {
  GALLERY_CLEAR_SEARCH_PARAMETERS,
  GALLERY_FETCH_PA_AGREEMENTS,
  GALLERY_RESULTS_AVAILABLE,
  GALLERY_SET_ASSET_TYPE_AND_FAMILY,
  GALLERY_SET_SEARCH_PARAMETER,
  GALLERY_TOGGLE_SEARCH_PARAMETER,
  GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES,
  GALLERY_FETCH_MORE_EVENTS,
  GALLERY_FETCH_MORE_GATEWAY_ASSETS,
} from 'app/actions/types';

import * as searchParameterPostProcessing from 'app/support/searchParameterPostProcessing';
import * as searchParameterMapping from 'app/support/searchParameterMapping';
import preservedSearchParameters from 'app/support/preservedSearchParameters';

const initialState = {
  id: 0,
  assets: [],
  availableSearchParameters: {},
  counts: { images: 0, films: 0 },
  events: [],
  queryCorrections: {},
  relatedTerms: [],
  renderGatewayView: false,
  searchParameters: {},
  searchProfile: {
    site: {},
  },
};

// eslint-disable-next-line complexity
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GALLERY_FETCH_PA_AGREEMENTS: {
      return {
        ...state,
        paAgreements: action.paAgreements,
      };
    }
    case GALLERY_FETCH_MORE_EVENTS: {
      // Map to remove duplicates by ID
      const events = Array.from(
        new Map(
          [...state.events, ...action.events].map((item) => [item.id, item])
        ).values()
      );
      return {
        ...state,
        events,
      };
    }
    case GALLERY_RESULTS_AVAILABLE: {
      const newState = {
        ...state,
        ...action.gallery,
      };
      newState.id += 1;
      return newState;
    }
    case GALLERY_CLEAR_SEARCH_PARAMETERS: {
      const updatedSearchParameters = preservedSearchParameters(state);
      return {
        ...state,
        searchParameters: updatedSearchParameters,
      };
    }
    case GALLERY_SET_ASSET_TYPE_AND_FAMILY: {
      const updatedSearchParameters = clone(state.searchParameters);
      updatedSearchParameters.assettype = action.assetType;
      updatedSearchParameters.family = action.family;
      return {
        ...state,
        ...searchParameterPostProcessing.getStateUpdatesForNewSearchParameters(
          state,
          updatedSearchParameters
        ),
      };
    }
    case GALLERY_SET_SEARCH_PARAMETER: {
      const cleanParameterName = searchParameterMapping.fromQueryKey(
        action.parameter
      );
      if (!state.availableSearchParameters[cleanParameterName]) {
        return state;
      }

      const updatedSearchParameters = clone(state.searchParameters);
      if (action.value === null || action.value === undefined) {
        delete updatedSearchParameters[cleanParameterName];
      } else {
        updatedSearchParameters[cleanParameterName] = action.value;
      }
      return {
        ...state,
        ...searchParameterPostProcessing.getStateUpdatesForNewSearchParameters(
          state,
          updatedSearchParameters
        ),
      };
    }
    case GALLERY_TOGGLE_SEARCH_PARAMETER: {
      const cleanParameterName = searchParameterMapping.fromQueryKey(
        action.parameter
      );
      if (!state.availableSearchParameters[cleanParameterName]) {
        return state;
      }

      const updatedSearchParameters = clone(state.searchParameters);
      updatedSearchParameters[cleanParameterName] =
        !updatedSearchParameters[cleanParameterName];
      return {
        ...state,
        ...searchParameterPostProcessing.getStateUpdatesForNewSearchParameters(
          state,
          updatedSearchParameters
        ),
      };
    }
    case GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES: {
      const cleanParameterName = searchParameterMapping.fromQueryKey(
        action.parameter
      );
      if (!state.availableSearchParameters[cleanParameterName]) {
        return state;
      }

      let newValues = state.searchParameters[cleanParameterName]
        ? [...state.searchParameters[cleanParameterName]]
        : [];
      const valuesToToggle = Array.isArray(action.values)
        ? action.values
        : [action.values];
      for (const valueToToggle of valuesToToggle) {
        if (newValues.includes(valueToToggle)) {
          newValues = newValues.filter((value) => value !== valueToToggle);
        } else {
          newValues.push(valueToToggle);
        }
      }
      const updatedSearchParameters = clone(state.searchParameters);
      if (newValues.length) {
        updatedSearchParameters[cleanParameterName] = newValues;
      } else {
        delete updatedSearchParameters[cleanParameterName];
      }
      return {
        ...state,
        ...searchParameterPostProcessing.getStateUpdatesForNewSearchParameters(
          state,
          updatedSearchParameters
        ),
      };
    }
    case GALLERY_FETCH_MORE_GATEWAY_ASSETS: {
      return {
        ...state,
        assets: [...state.assets, ...action.assets],
      };
    }
    default:
      return state;
  }
};
